'use client';
import { useEffect } from 'react';

import { useSubscriptionClock } from '@/hooks/useSubscriptionClock';
import { useSubscriptionListener } from '@/hooks/useSubscriptionListener';
import { getTenantIdFromSession } from '@/lib/tenant/session';
import { useSubscriptionStore } from '@/store/subscriptionStore';

/**
 * Headless global component — no rendered UI.
 * Boots the real-time subscription listener and the 60s clock tick.
 * Also seeds fetchActiveSubscription + fetchPlans once on mount so the
 * SubscriptionBanner (Phase 5) has data available on every page.
 *
 * Mount once in providers.tsx alongside <AuthSync />.
 */
export function SubscriptionEnforcer() {
  // Activates Supabase realtime listener
  useSubscriptionListener();

  // Ticks every 60s — consumed by SubscriptionBanner to re-evaluate expiry
  useSubscriptionClock();

  useEffect(() => {
    const tenantId = getTenantIdFromSession();
    if (!tenantId) return;

    const { fetchActiveSubscription, fetchPlans } =
      useSubscriptionStore.getState();

    fetchActiveSubscription(tenantId).then(() => {
      fetchPlans(tenantId);
    });
  }, []);

  return null;
}
